import { ReactElement } from 'react';
import { useEditor } from '@craftjs/core';
import { useTranslation } from '@frontend/i18n';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip } from '@frontend/design-system';
import { useContentComposer } from '../content-composer-provider';
import { ListButton } from './list-button';

export type ToolboxButtonProps = {
  icon?: IconName;
  title?: string;
  subtitle?: string;
  showBetaLabel?: boolean;
  onClick: () => void;
  children?: ReactElement;
  trackingId?: string;
};

export const ToolboxButton = ({
  icon,
  title,
  subtitle,
  onClick,
  children,
  showBetaLabel,
  ...rest
}: ToolboxButtonProps) => {
  const { connectors } = useEditor();
  const { composerMode } = useContentComposer();
  const isFeedbackMode = composerMode == 'feedback';

  const { t } = useTranslation('content-composer');

  return (
    <ListButton onClick={onClick} {...rest} ref={(ref) => (ref && children ? connectors.create(ref, children) : null)}>
      {icon && (
        <ListButton.Lead>
          <Icon
            name={icon}
            css={{
              maxWidth: 'initial',
              color: isFeedbackMode ? theme.colors.neutral50 : 'inherit',
            }}
          />
        </ListButton.Lead>
      )}
      {(title || subtitle) && (
        <ListButton.Content>
          {title && <ListButton.Content.Title>{title}</ListButton.Content.Title>}
          {subtitle && <ListButton.Content.Subtitle>{subtitle}</ListButton.Content.Subtitle>}
        </ListButton.Content>
      )}
      {showBetaLabel && (
        <Chip
          variant='seaweed'
          css={{
            justifySelf: 'flex-end',
            width: '49px',
            height: '32px',
            padding: theme.spacing(0.5),
          }}
        >
          {t('Beta')}
        </Chip>
      )}
    </ListButton>
  );
};
